import {
    REVERT_RMA_REQUEST,
    REVERT_RMA_RESULT,
    REVERT_RMA_OPEN_MODAL,
    REVERT_RMA_CLOSE_MODAL,
    REVERT_RMA_GET_DEVICE_REQUEST,
    REVERT_RMA_GET_DEVICE_RESULT,
    REVERT_RMA_SET_DEVICE,
} from 'Redux/actionTypes';

export const revertRmaRequest = (data) => ({
    type: REVERT_RMA_REQUEST,
    payload: data
})

export const revertRmaResult = (result) => ({
    type: REVERT_RMA_RESULT,
    payload: result
})

export const revertRmaOpenModal = (items) => ({
    type: REVERT_RMA_OPEN_MODAL,
    payload: items
})

export const revertRmaCloseModal = () => ({
    type: REVERT_RMA_CLOSE_MODAL
})

export const revertRmaGetDeviceRequest = (item) => ({
    type: REVERT_RMA_GET_DEVICE_REQUEST,
    payload: item
})

export const revertRmaGetDeviceResult = (result) => ({
    type: REVERT_RMA_GET_DEVICE_RESULT,
    payload: result
})

export const revertRmaSetDevice = (device) => ({
    type: REVERT_RMA_SET_DEVICE,
    payload: device
})